import "./App.less";
import { Switch, Route } from "react-router-dom";
import dotenv from "dotenv";

import TermsAndConditions from "./components/TermsAndConditions";

// import User
import LoginPage from "./pages/User/LoginPage";
import HomePage from "./pages/User/HomePage";
import ForgotPasswordPage from "./pages/User/ForgotPasswordPage";
import ResetPasswordPage from "./pages/User/ResetPasswordPage";
import EmailVerificationPage from "./pages/User/EmailVerificationPage";
import JobDetailPage from "./pages/JobDetailPage";
import AllNotifications from "./components/Utilities/AllNotifications";

// import Client
import ClientRegister from "./pages/Client/ClientRegister";
import ClientT24Profile from "./pages/Client/ClientProfile";
import ClientHomePage from "./pages/Client/ClientHomePage";
import NewJobPage from "./pages/Client/NewJobPage";
import ViewApplications from "./components/Client/Job/ViewApplications";
import ClientDashboard from "./components/Client/ClientDashboard";
import ViewJob from "./components/Client/Job/ViewJob";
import ClientProfile from "./components/Client/Profile/ClientProfile";

// import Consultant pages
import ConsultantRegister from "./pages/Consultant/ConsultantRegister";
import ConsultantHomePage from "./pages/Consultant/ConsultantHomePage";
// import Skills from "./components/Consultant/Skills";
import Applications from "./components/Consultant/Skills/Applications";
import ApplicationDetail from "./components/Consultant/ApplicationDetail";
import Offers from "./components/Consultant/Offers";
import ChangePasswordForm from "./components/Forms/ChangePasswordForm";
import ActiveJobs from "./components/Consultant/ActiveJobs";
import ViewProgress from "./components/Consultant/ViewProgress";
import Profile from "./components/Consultant/Profile/Profile";
import ConsultantDashborad from "./components/Consultant/ConsultantDashborad";

// Admin Pages
import AdminHome from "./components/Admin/AdminHome";
import InternalServerError from "./components/InternalServerError";
import PageNotFound from "./components/PageNotFound";

dotenv.config();

const App = () => {
  return (
    <Switch>
      <Route exact path="/" component={HomePage}></Route>
      <Route exact path="/login" component={LoginPage}></Route>
      <Route
        exact
        path="/forgot-password"
        component={ForgotPasswordPage}
      ></Route>
      <Route
        exact
        path="/change-password"
        component={ChangePasswordForm}
      ></Route>
      <Route
        exact
        path="/reset-password/:resetToken"
        component={ResetPasswordPage}
      ></Route>
      <Route
        exact
        path="/registration/client"
        component={ClientRegister}
      ></Route>
      <Route
        exact
        path="/registration/consultant"
        component={ConsultantRegister}
      ></Route>
      <Route
        exact
        path="/registration/t24"
        component={ClientT24Profile}
      ></Route>
      <Route
        exact
        path="/terms-conditions"
        component={TermsAndConditions}
      ></Route>
      <Route
        exact
        path="/verification/email/:token"
        component={EmailVerificationPage}
      />
      <Route exact path="/client/home" component={ClientHomePage} />
      <Route exact path="/consultant/home" component={ConsultantHomePage} />
      <Route exact path="/client/new-job" component={NewJobPage} />
      <Route exact path="/job/:jobId" component={JobDetailPage} />
      <Route
        exact
        path="/consultant/profile/account"
        component={Profile}
      ></Route>
      <Route
        exact
        path="/consultant/profile/skills"
        component={Profile}
      ></Route>
      <Route
        exact
        path="/client/:jobId/applications"
        component={ViewApplications}
      />
      <Route exact path="/consultant/applications" component={Applications} />
      <Route
        exact
        path="/consultant/application/:applicationId"
        component={ApplicationDetail}
      />
      <Route exact path="/consultant/offers/" component={Offers} />
      <Route exact path="/consultant/jobs" component={ActiveJobs}></Route>
      <Route
        exact
        path="/consultant/dashboard"
        component={ConsultantDashborad}
      />
      <Route
        exact
        path="/job/:jobId/progress/:offerId"
        component={ViewProgress}
      ></Route>
      <Route exact path="/notifications" component={AllNotifications}></Route>
      <Route exact path="/client/dashboard" component={ClientDashboard}></Route>
      <Route
        exact
        path="/client/profile/account"
        component={ClientProfile}
      ></Route>
      <Route
        exact
        path="/client/profile/security"
        component={ClientProfile}
      ></Route>
      <Route exact path="/client/job/:jobId" component={ViewJob}></Route>
      <Route exact path="/admin/home" component={AdminHome} />
      <Route exact path="/error" component={InternalServerError}></Route>
      <Route component={PageNotFound} />
    </Switch>
  );
};

export default App;

// https://tecknoworks.com/how-to-integrate-social-login-in-a-web-api-solution/

// for profile
// https://codepen.io/moadqarbal/pen/mdPNpNm


//https://cdn.dribbble.com/users/920320/screenshots/11020790/media/156f9f885e468c60dd7d6d539f2ee1bb.png?compress=1&resize=1200x900
